// VisitorsSection.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./VisitorsSection.css";
import analyticsService from "../../../services/analyticsService";
import socketClient from "../../../services/socketClient";

function VisitorsSection() {
  const [visitors, setVisitors] = useState({
    today: 0,
    yesterday: 0,
    week: 0,
    month: 0,
    lastMonth: 0,
  });

  const [currentOnline, setCurrentOnline] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch dashboard analytics data
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await analyticsService.getDashboardAnalytics();

        if (response.success && response.data) {
          const { onlineUsers, visitors: visitorData } = response.data;

          setCurrentOnline(onlineUsers || 0);

          if (visitorData) {
            setVisitors({
              today: visitorData.today || 0,
              yesterday: visitorData.yesterday || 0,
              week: visitorData.week || 0,
              month: visitorData.month || 0,
              lastMonth: visitorData.lastMonth || 0,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching visitor analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    // Connect Socket.io for real-time online users updates
    socketClient.connect();
    socketClient.onOnlineUsersUpdate((data) => {
      if (data && typeof data.count === 'number') {
        setCurrentOnline(data.count);
      }
    });

    // Handle window resize for responsive design
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
      socketClient.removeListener('analytics:online-users');
    };
  }, []);

  return (
    <motion.div
      className="visitors-section"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className={`visitor-section-title ${isMobile ? 'mobile-view' : ''}`}>
        <div className="title-text">
          <h2>Visitors &amp; Online</h2>
        </div>
        <div className="live-online">
          <h3>Online: {currentOnline}</h3>
          <span className="material-symbols-outlined">groups</span>
        </div>
      </div>

      <div className="visitors-cards">
        <div className="visitor-card">
          <span className="material-symbols-outlined">ads_click</span>
          <p className="visitor-date">Today</p>
          <p className="visitor-number">{visitors.today} Visitors</p>
        </div>
        <div className="visitor-card">
          <span className="material-symbols-outlined">ads_click</span>
          <p className="visitor-date">Yesterday</p>
          <p className="visitor-number">{visitors.yesterday} Visitors</p>
        </div>
        <div className="visitor-card">
          <span className="material-symbols-outlined">ads_click</span>
          <p className="visitor-date">Week</p>
          <p className="visitor-number">{visitors.week} Visitors</p>
        </div>
        <div className="visitor-card">
          <span className="material-symbols-outlined">ads_click</span>
          <p className="visitor-date">Month</p>
          <p className="visitor-number">{visitors.month} Visitors</p>
        </div>
        <div className="visitor-card">
          <span className="material-symbols-outlined">ads_click</span>
          <p className="visitor-date">Last Month</p>
          <p className="visitor-number">{visitors.lastMonth} Visitors</p>
        </div>
      </div>
    </motion.div>
  );
}

export default VisitorsSection;
